import { Duration } from "luxon";

export class LocationsToAddInJobs {
  locationId!: string;
  address!: string;
  locationName!:string;
  locationNameAndAddress!:string;
  serviceTime!: Duration;
  serviceToTime! : Duration;
  productId !: string;
}
